//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from 'lodash';
import dialogMixin from '@/mixin/dialog';

export default {
  name: 'TeacherDialog',
  mixins: [dialogMixin],
  props: { id: { type: Number, default: 0 } },
  data() {
    return {
      rate: 4.3,
      itemData: {},
      rateList: [],
    };
  },
  methods: {
    isEmpty,
    getLecturer() {
      this.$api('getLecturerAuth', { lecturerId: this.id }).then(data => {
        this.itemData = data;
      });
    },
    getRate() {
      this.$api('getLecturerOwnerEvaluation', { lecturerId: this.id }).then(
        data => {
          this.rateList = data.records;
        },
      );
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
    onClose() {
      this.close();
      this.resetData();
    },
    onOpen() {
      if (this.id) {
        this.getLecturer();
        this.getRate();
      }
    },
  },
};
